import { sdkRequest } from '@eventbrite/http';
import {
    checkEbAdsEligibility,
    checkEventLocationEligibility,
    mapToPreviewEvent,
} from '@eventbrite/promoted-events-ui';
import { EventCampaignAssociation } from '../components/event-marketing-card/EventMarketingCard';
import { EventsAPIResponse, EventWithFullExpansion } from '../constants';

export const getEventData = (
    eventID: string | undefined,
): Promise<EventsAPIResponse & EventWithFullExpansion> => {
    return sdkRequest(
        `/api/v3/events/${eventID}/?expand=ticket_classes,facebook,series_dates,venue`,
    );
};

export const getEventsData = (activeOrganizationId: string) => {
    return sdkRequest(
        `/api/v3/organizations/${activeOrganizationId}/events/?order_by=created_desc&show_series_parent=true`,
    );
};

export const getEmailCampaignsForEvent = (
    activeOrganizationId: string,
    eventId: string,
): Promise<Array<EventCampaignAssociation>> => {
    return sdkRequest(
        `/api/v3/organizations/${activeOrganizationId}/missive/event_campaign_associations/?event_ids=${eventId}&active_only=true`,
    );
};

export const getEmailCampaignsForOrganization = (
    activeOrganizationId: string,
) => {
    return sdkRequest(
        `/api/v3/organizations/${activeOrganizationId}/missive/campaigns`,
    );
};

export const getEmailStatsForOrganization = (activeOrganizationId: string) => {
    return sdkRequest(
        `/api/v3/organizations/${activeOrganizationId}/missive/organization_stats`,
    );
};

export const getEbAdsEligibilityStatus = async (
    activeOrganizationId: string,
    skipCache?: boolean,
) => {
    const isEbAdsEligible = await checkEbAdsEligibility(
        (isEligible: boolean) => isEligible,
        activeOrganizationId,
        skipCache,
    );

    return isEbAdsEligible;
};

export const getEventEBAdsEligibilityStatus = async (
    event?: EventWithFullExpansion,
) => {
    const previewEvent = await mapToPreviewEvent(event);

    const isEligible = checkEventLocationEligibility(previewEvent);
    return isEligible;
};
